import { oc } from '@orpc/contract';
import { segmentSchema, updateSegmentInputSchema } from '../schemas/segments.schemas.js';
export const updateSegmentContract = oc
    .route({
    method: 'PATCH',
    path: '/segments/{id}',
    tags: ['Segments'],
    summary: 'Update a vehicle segment',
    description: 'MANAGER only. Only the supplied fields change.',
})
    .input(updateSegmentInputSchema)
    .output(segmentSchema);
//# sourceMappingURL=update-segment.contract.js.map